import React, { memo, useMemo } from 'react'
import moment from 'moment'

import { Icon } from '../../../components/UI'

const FindTutorCalendarViewTimeSlot = ({
  children: { props },
  value,
  slots = [],
  alreadySelectedData,
  selectedSlot,
  setSelectedSlot,
}) => {
  const timeSlot = useMemo(() => {
    if (!slots.length) {
      return null
    }

    const day = moment(value).format('YYYY-MM-DD')
    const hour = moment(value).format('H')

    return slots.find((slot) => slot.slot === hour && slot.day === day)
  }, [value, slots])

  const isAlreadySelected = alreadySelectedData
    ? moment(value).format('YYYY-MM-DD') === alreadySelectedData.day &&
      moment(value).format('H') === alreadySelectedData.slot
    : false
  const isAvailable = !!timeSlot
  const isSelected =
    timeSlot && selectedSlot
      ? timeSlot.day === selectedSlot.day && timeSlot.slot === selectedSlot.slot
      : false
  const isScheduled = false

  const handleSchedule = () => {
    if (isScheduled || !timeSlot) {
      return
    }

    setSelectedSlot(isSelected ? null : timeSlot)
  }

  if (props.children) {
    return null
  }

  return (
    <div
      onClick={handleSchedule}
      className={`absolute w-full h-full ${isAlreadySelected ? 'bg-[#F9E0CE]' : ''} ${isAvailable && !isScheduled && !isAlreadySelected ? `cursor-pointer ${isSelected ? 'bg-[#0DA545] hover:bg-[#1AC057]' : 'bg-[#1AC057] hover:bg-[#32D96F]'}` : 'pointer-events-none'} ${isScheduled && !isAlreadySelected ? 'bg-[#0DA545]' : ''} flex items-center justify-center transition-colors duration-200 ease`}
    >
      <span
        className={`text-xs font-medium ${isAvailable || isScheduled ? 'text-[#FDFDFD]' : 'text-primary-100'}`}
      >
        {moment(value).format('HH:mm')}
      </span>

      {isScheduled && (
        <Icon name="pushpin-fill" color="#FDFDFD" className="ml-[8px] w-[20px] h-[20px]" />
      )}
    </div>
  )
}

export default memo(FindTutorCalendarViewTimeSlot)
